import { useMemo } from 'react';
import { HStack, Skeleton, useColorModeValue } from '@chakra-ui/react';
import { isEmpty } from 'lodash';

export default function MultiSelectLikedMembersListV2({
  members,
  selectedMemberIds,
  onMemberSelect,
  isAllMember = false,
  isShowHeartEmoji = false,
}) {
  const startColor = useColorModeValue('separator.light.1', 'separator.dark.1');
  const endColor = useColorModeValue('separator.light.2', 'separator.dark.2');
  const primaryStartColor = useColorModeValue('secondary.light', 'secondary.dark');
  const primaryEndColor = useColorModeValue('theirty.light', 'theirty.dark');

  const isSelectedMember = (member) => {
    return selectedMemberIds.some(selectedMemberId => selectedMemberId === member.memberId);
  };

  const handleMemberClick = (member) => {
    onMemberSelect?.(member);
  };

  const membersList = useMemo(() => {
    return members || [];
  }, [members]);

  return (
    <>
      {!isEmpty(members) ? (
        <div className="flex flex-wrap gap-[6px]">
          {membersList?.map((member) => {
            const isSelected = isSelectedMember(member);

            return (
              <button
                key={member.memberId}
                onClick={() => handleMemberClick(member)}
                className={`
                  flex items-center justify-center gap-[4px] rounded-[32px] border border-solid
                  px-[12px] py-[8px] text-[13px] font-medium
                  bg-pure-white dark:bg-pure-black
                  border-separator-light-1 dark:border-separator-dark-1
                  ${isSelected
                    ? 'text-primary-light dark:text-primary-dark'
                    : 'text-main-light-2 dark:text-main-dark-2'
                  }
                  ${isAllMember && 'opacity-50'}
                `}
                style={{
                  minWidth: '37px',
                  minHeight: '33px',
                }}
              >
                <div>{member.name}</div>
                {isShowHeartEmoji && member.isLiked && (
                  <div>♥</div>
                )}
              </button>
            );
          })}
        </div>
      ) : (
        <HStack paddingY={'8px'}>
          <Skeleton
            height="33px"
            width="47px"
            borderRadius={'32px'}
            startColor={primaryStartColor}
            endColor={primaryEndColor}
          />
          <Skeleton
            height="33px"
            width="47px"
            borderRadius={'32px'}
            startColor={startColor}
            endColor={endColor}
          />
          <Skeleton
            height="33px"
            width="47px"
            borderRadius={'32px'}
            startColor={startColor}
            endColor={endColor}
          />
        </HStack>
      )}
    </>
  );
}
